import { connect } from "react-redux";
import MaterialDelivery from "./tagDelivery";
import { bindActionCreators } from "redux";
import {
  getTagDelivery,
  getTags,
  postTagDelivery,
  updateStatus,
} from "services/redux/installation/tagDelivery/action";
import { getSiteInspect,getPocBySiteId,
  postSendReportMail } from "services/redux/installation/siteInspection/action";
import { generateReport } from "services/redux/installation/materialRequisition/action";
import {getSiteData, calculateDistance, getDistanceData} from "../../../services/redux/DistanceCalculator/action";

const mapStateToProps = (state) => ({
  materialData: state.tagDeliveryReducer.tagData,
  tags: state.tagDeliveryReducer.tags,
  siteData: state.siteInspectionReducer.siteData,
  pocListBySiteId: state.siteInspectionReducer.pocListBySiteId,
  siteDetails: state.leadDataReducer.siteData,
  engDistanceData: state.leadDataReducer.engDistanceData,
  distanceDetails: state.leadDataReducer.distanceDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getTagDelivery,
      getTags,
      postTagDelivery,
      updateStatus,
      getSiteInspect,
      generateReport,
      getPocBySiteId,
      postSendReportMail,
      getSiteData,
      calculateDistance,
      getDistanceData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MaterialDelivery);
